import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

const LicenseeFilters = (props) => {
    const {countries} = props.data,
        loading = props.loading;

    return (
        <div className='licensees__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={props.filters.Licensees}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={props.filters.Licensees}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

LicenseeFilters.defaultProps = {
    countries: [],
};

LicenseeFilters.propTypes = {
    countries: PropTypes.array,
    data: PropTypes.object,
    filters: PropTypes.object,
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(LicenseeFilters, {name: 'Licensees'});
